import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ICurrencyPairGroupPromiseLookupService } from "../ICurrencyPairGroupPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { CurrencyPairGroupLookupService } from "./CurrencyPairGroupLookupService";
import { CcyPairLookupService } from "./CcyPairLookupService";

@Injectable()
export class CurrencyPairGroupReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.CurrencyPairGroupImpl>
  implements ICurrencyPairGroupPromiseLookupService
{
  protected pairIdx: Map<Number, Set<string>> = new Map();

  constructor(
    protected factory: ClientMessageBrokerFactory,
    protected ccyPairService: CcyPairLookupService,
  ) {
    super(
      factory,
      CubiqTS.CurrencyPairGroupImpl,
      "CurrencyPairGroupImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new CurrencyPairGroupLookupService(ccyPairService),
    );

    this.indexData();
  }

  indexData(): void {
    this.isPrimed().then((primed) => {
      this.getAll().then((found) => {
        if (found)
          found.forEach((pairGrp) => {
            this.indexItem(pairGrp);
          });
      });
    });
  }
  /**
   * we need to build some additional indices
   * so we can get the pairs for a group id
   */
  indexItem(group: CubiqTS.CurrencyPairGroupImpl): void {
    let id: number = group.id.toNumber(); // Map didn't like the Long as a key
    let groupPairs: Set<string> = this.pairIdx.get(id);
    if (null == groupPairs) {
      groupPairs = new Set<string>();
      this.pairIdx.set(id, groupPairs);
    }
    if (group.groupMembership)
      group.groupMembership.map((pair: CubiqTS.CurrencyPairGroupMember) => {
        let productKey: string = pair.baseCurrencyCd + pair.nonBaseCurrencyCd;
        groupPairs.add(productKey);
      });
  }

  getPairs(groupId: Number): string[] {
    let ret: string[] = [];
    let found: Set<string> = this.pairIdx.get(groupId);
    if (found) ret = Array.from(found); // so nobody screws with the cache
    return ret;
  }
}
